class General {

    constructor() {
        document.addEventListener("scroll", this.fixedNavbar);
    }

    fixedNavbar() {
        const navbar = document.getElementById("bottom_header");
        const content = document.getElementById("masthead");

        if (window.scrollY > 50) {
            navbar.classList.add("fixed-top");
            // add padding top to show content behind navbar
            const navbar_height = navbar.offsetHeight;
            content.style.paddingTop = navbar_height + "px";
        } else {
            navbar.classList.remove("fixed-top");
            // remove padding top from body
            content.style.paddingTop = "0";
        }
    }
}

export default General;